/**
 * 收货地址 回显
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2023, all rights reserved. Essa.cn
 *
 **/
import React from "react";
import {trim,isEmpty,isEmptyObject} from '@utils/utils';
import './index.less'
export default class Consignee extends React.Component{
    static defaultProps = {
        address:{}, //只展示当前
        on: true, // 展示选中效果
    };
    componentDidMount() {
        if( this.props.onRef)this.props.onRef(this);
    };
    render() {
        const { address, on,canClick} = this.props;
        return (<div className={`addressWrap${on?" addressPickWrap":""}${canClick?" cursor-p":""}`}
                     key={on+"_"+address.id}
            // onClick={canClick?()=>this.onClickAddress(address):null}
        >
            <div className={"cont black89"}>
                <p className={"black45"}>{address.cityName}，{address.countryName}</p>
                <p>{address.detailedAddress}</p>
                <p className={"fw_700 mt_20"}>{address.name}</p>
                <p className={"fw_700"}>+{address.telCode}<span className={"ml_4"}>{address.monde}</span></p>
            </div>
        </div>);
    }
}

